var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"full",attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"d-flex justify-center"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }